<template>
  <div class="unbind-apply" data-automation="unbindApply">
    <ux-table
      ref="table"
      maxHeight="100%"
      :hide-on-single-page="true"
      :data="list"
      :columns="columns"
      layout="total, sizes, prev, pager, next"
      :emptyText="$t('HT.nodata')"
    ></ux-table>

    <my-footer-btn spacing="80px" padding="10px" hideConfirm @close="close"></my-footer-btn>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns: [
        // 表头数据
        {
          label: this.$t('HT.unbindApply.name'),
          prop: 'name',
          tooltip: true
        },
        {
          label: this.$t('HT.unbindApply.ipAddress'),
          prop: 'ip_address',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return cellValue;
          }
        },
        {
          label: this.$t('HT.operation'),
          hidden: false,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.unbind')],
                colors: ['#0087ff'],
                event: ['unbind']
              },
              on: {
                unbind: () => {
                  const title = this.$t('HT.unbind.title');
                  this.$uxModal.show({
                    title,
                    content: ''
                  });
                }
              },
              confirm: () => {
                params.id = this.data.id;
                this.unbind(params);
              }
            });
          }
        }
      ],
      list: []
    };
  },
  created() {
    this.getInfoList(this.data.id);
  },
  methods: {
    close() {
      this.$uxModal.hide();
    },

    /**
     * 获取流量控制绑定的应用
     * @param {Number} id 唯一标识
     */
    getInfoList(id) {
      this.$uxLoading.show();
      this.$api.access.getInfoList(id).then((res) => {
        if (res.code == 10000) {
          this.list = res.data;
        }
      });
    },

    /**
     * 解绑
     * @param {Object} params 对象
     */
    unbind(params) {
      this.$uxLoading.show();
      this.$api.access.unbind(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.unbindSuccess'));
          this.getInfoList(this.data.id);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.unbind-apply {
  width: 700px;
}
</style>
